'use strict'

const maybe = require('folktale/maybe')

const currentUserFilterResolver = wixCodeSdk => () =>
  maybe
    .fromNullable(wixCodeSdk.user.currentUser)
    .map(({ id, loggedIn }) => (loggedIn ? id : null))

module.exports = currentUserFilterResolver



// WEBPACK FOOTER //
// ./filter-resolvers/currentUser.js